// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__2EuH0","title__low":"style_title__low__2cBx2"};